import { render, staticRenderFns } from "./ListaDupla.vue?vue&type=template&id=de4a3fc2&scoped=true"
import script from "./ListaDupla.vue?vue&type=script&lang=js"
export * from "./ListaDupla.vue?vue&type=script&lang=js"
import style0 from "./ListaDupla.vue?vue&type=style&index=0&id=de4a3fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4a3fc2",
  null
  
)

export default component.exports